export const UPDATE_TICKET = 'update_ticket';
export const ADD_TICKET = 'add_ticket';
